
    export interface VFMModalBeforeOpenEvent {
        stop: () => void;
        ref: {
            params: Ref<any>;
            emit: Function;
        };
    }

    import _ from 'lodash';
    import { Ref } from 'vue';
    import { Options, Vue } from 'vue-class-component';

    @Options<ApModalBase>({
        props: {
            name: String,
            title: String,
            wrapper: {
                type: String,
                default: 'div',
            },
            titleIcon: {
                type: String,
                default: '',
            },
            showClose: {
                type: Boolean,
                default: true,
            },
            cancelOverride: {
                type: Boolean,
                default: false,
            },
            cancelText: String,
            width: {
                type: [String, Number],
                default: '368',
            },
            height: {
                type: [String, Number],
                default: '400',
            },
            header: {
                type: Boolean,
                default: true,
            },
            footer: {
                type: Boolean,
                default: true,
            },
            footerClass: {
                type: String,
                default: 'same-width',
            },
            scollPadding: {
                type: Boolean,
                default: true,
            },
            clickToClose: {
                type: Boolean,
                default: false,
            },
            cancelOverflow: {
                type: Boolean,
                default: false,
            },
        },
    })
    export default class ApModalBase extends Vue {
        public contentHeight = '';

        public readonly name!: string;
        public readonly title!: string | null;
        public readonly cancelOverride!: boolean;
        public readonly cancelText!: string | null;
        public readonly width!: string | number;
        public readonly height!: string | number;
        public readonly header!: boolean;
        public readonly footer!: boolean;
        public readonly clickToClose!: boolean;
        public readonly titleIcon!: string;
        public readonly showClose!: boolean;
        public readonly scollPadding!: boolean;
        public readonly footerClass!: string;
        public readonly wrapper!: string;
        public readonly cancelOverflow!: boolean;
        public ParamsTitle: string | null = null;

        public showModal = false;

        get contentClass() {
            let classes = ['vm--modal'];
            if (this.cancelOverflow) {
                classes.push('cancel-overflow');
            }
            return classes;
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        get contentStyle(): any {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const attr: any = {};
            if (this.height !== undefined || this.height !== null) {
                attr.height = Number(this.height) == this.height ? this.height + 'px' : this.height;
            }
            return attr;
        }

        get widthCalc() {
            var w = this.width;
            if (w && _.startsWith(String(w), 'full')) w = '100%';
            else w = w + 'px';
            return w;
        }

        get hasAfterFooter(): boolean {
            return this.$slots.AfterFooter ? true : false;
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        get AfterFooterStyle(): any {
            const h = this.contentHeight;
            if (h) {
                return {
                    maxHeight: 'calc(100vh - ' + h + 'px)',
                };
            } else return {};
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        public beforeOpen(event: any): void {
            this.ParamsTitle = this.title;
            let newEvent = {
                ref: event.ref,
                params: event.ref?.params?.value,
                cancel: () => event.ref.emit('update:modelValue', false),
            };
            this.$emit('open', newEvent);
            if (event.ref?.params?.value?.title) {
                this.ParamsTitle = event.ref.params.value.title;
            }
        }

        public onCancel() {
            if (this.cancelOverride) this.emitCancel();
            else this.$vfm.hide(this.name);
        }

        public emitCancel(): void {
            this.$emit('on-cancel');
        }

        public opened(): void {
            this.$emit('opened', this);
            if (this.hasAfterFooter) {
                this.$nextTick(() => {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const header: any = this.$refs.header;
                    const h1 = header && header.offsetHeight;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const content: any = this.$refs.content;
                    const h2 = content && content.offsetHeight;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const footer: any = this.$refs.footer;
                    const h3 = footer && footer.offsetHeight;
                    if (h1 && h2) {
                        this.contentHeight = h1 + h2 + h3 + 20;
                    }
                });
            }
        }
    }
